import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';

import BreadcrumbZuwendungsantrag from './BreadcrumbZuwendungsantrag';
import BreadCrumbVerwendungsnachweis from './BreadCrumbVerwendungsnachweis';
import BreadCrumbMittelAbruf from './BreadCrumbMittelAbruf';

const ApplicationBreadcrumbs: FC<{ api: string }> = ({ api }) => {
	const RenderContent = () => {
		switch (api) {
			case APIS.Zuwendungsantrag:
				return <BreadcrumbZuwendungsantrag />;
			case APIS.Mittelabruf:
				return <BreadCrumbMittelAbruf />;
			case APIS.Verwendungsnachweis:
				return <BreadCrumbVerwendungsnachweis />;

			default:
				return <></>;
		}
	};

	return <RenderContent />;
};

export default ApplicationBreadcrumbs;
